import {
  EnumCommodity,
  EnumEstadoCliente,
  EnumIdioma,
  EnumPais,
  EnumSubtipoSujeto,
  EnumTipoDocumentoFiscal,
  EnumTipoDocumentoIdentidad,
  EnumTipoResidencia,
  EnumTipoSujeto,
  EnumTipoSuministro,
  EnumZonaBalance
} from '../../api'
import { ProcedureTypes } from '../../api/Argentia/enums'
import { AddressTypeEnum } from '../../api/Argentia/enums/addressTypeEnum'
import { EnumTipoNotificacion } from '../../api/oData/enums/enumTipoNotificacion'
import { DataTableActionConfiguration } from '../../model'

export enum TabsInfoClient {
  generalData = 1,
  auxiliaryData = 2
}

export interface SubjectModel {
  id?: number
  type?: EnumTipoSujeto
  subtype?: EnumSubtipoSujeto
  commodityType?: EnumTipoSuministro
  commodity?: EnumCommodity
  personType: EnumTipoDocumentoFiscal
  documentType: EnumTipoDocumentoIdentidad
  documentID: string
  name: string
  surname1: string
  surname2: string
  businessName: string
  description?: string
  fiscalAddress: FiscalAddressModel
  contactInfo: ContactInfoModel[]
  language: EnumIdioma
  residenceType?: EnumTipoResidencia
  nationality?: EnumPais
  companyID: number
  balanceZone?: EnumZonaBalance
  clientCode?: string
  erpCode?: string
  state: EnumEstadoCliente
  fatherSubject?: SubjectModel
  removeFatherSubject?: boolean
  updateFatherSubject?: boolean
}

export interface ClientFileModel extends Omit<SubjectModel, 'contactInfo'> {
  contactInfo: ContactInfoWithPrincipalIcon[]
}

export interface ContactInfoWithPrincipalIcon extends ContactInfoModel {
  iconConfiguration?: DataTableActionConfiguration[]
  action?: any
}

export interface ClientGeneralDataFormModel {
  clientId?: number
  clientType?: EnumSubtipoSujeto
  commodity?: EnumTipoSuministro | null
  personType?: EnumTipoDocumentoFiscal
  state?: EnumEstadoCliente
  fatherSubjectId?: number
  removeFatherSubject?: boolean
  updateFatherSubject?: boolean
  name?: string
  surname1?: string
  surname2?: string
  businessName?: string
  documentType?: EnumTipoDocumentoIdentidad
  documentId?: string
  fiscalAddressId?: number
  postalAddress?: string
  postalCode?: string
  municipality?: string
  province?: string
  country?: string
  municipalityId?: number
  provinceId?: number
  countryId?: number
  contactInfoId?: number
  email?: string
  phoneNumber?: string
  language?: EnumIdioma
  notifications?: EnumTipoNotificacion
  contractId?: number
  additionalInfo?: string
  nationality?: EnumPais
  residenceType?: EnumTipoResidencia
  clientCode?: string
  erpCode?: string
}

// export interface ClientAuxiliaryDataFormModel {
//     nationality?: SelectOption,
//     residenceType?: SelectOption
// }

export interface FiscalAddressModel {
  Id?: number
  postalAddress: string
  postalCode: string
  municipality: string
  province: string
  country: string
  municipalityId?: number
  provinceId?: number
  countryId?: number
  addressType?: AddressTypeEnum
  cupsId?: number
  paymentMethodId?: number
}

export interface ContactInfoModel {
  id?: number
  clientId?: number
  contactName: string
  email?: string
  phoneNumber?: string
  notificationType?: EnumTipoNotificacion
  principal: boolean
  comments?: string
  contractId?: number
  canDelete?: boolean
  actionsConfiguration?: Array<DataTableActionConfiguration>
  actions?: any
}

export interface IdentificationDocumentModel {
  id: number
  description: string
  personType: EnumTipoDocumentoFiscal
}

export interface SubjectTableModel {
  id: number
  fiscalDocument: string
  description: string
  contractsList: ContractsListModel[]
  contractIDList: number[]
  cupsCodeList: string[]
  contractsCode: string
  cupsCode: string
  commodity: EnumCommodity
  status: EnumEstadoCliente
}

export type ContractsListModel = {
  code: string
  status: EnumEstadoCliente
}

export interface SubjectFilterModel {
  searchText?: string
  subjectTypeList: EnumTipoSujeto[]
  isActive?: boolean
  commodity?: EnumCommodity
  companyID: number
}

export enum TabsClientType {
  FINAL_CLIENT = 6,
  EXTENDED_CLIENT = 12,
  WHOLESALER = 1,
  COMMERCIAL = 8,
  SHIPPER = 4,
  DISTRIBUTION = 3
}

export interface SubjectAnnouncementModel {
  activeSubjectWithoutContracts: ActiveSubjectModel[]
  contractsSubjectNextExpiration: ContractsSubjectNextExpirationModel[]
  proceduresInProgress: ProcedureKpisModel[]
  incidentProcedures: ProcedureKpisModel[]
}
export interface ActiveSubjectModel {
  id: number
  fiscalDocument: string
  subjectName: string
}
export interface ContractsSubjectNextExpirationModel {
  id: number
  contractCode: string
  fiscalDocument: string
  subjectId: number
  subjectName: string
}
export interface ProcedureKpisModel {
  id: number
  comunicationDate: Date
  subjectId: number
  subject: string
  cupsId: number
  cups: string
  type: ProcedureTypes
}

export interface LandingSubjectAnnouncementFilterModel {
  subjectTypes: EnumTipoSujeto[]
  subjectStates: EnumEstadoCliente[]
  commodity?: EnumCommodity
  companyID: number
}

export interface ActiveContractsFilterModel {
  subjectTypes: EnumTipoSujeto[]
  commodity?: EnumCommodity
  companyID: number
  date: Date
}

export interface LandingSujectKpisModel {
  activeContracts: number
  balance30: number
  balanceYtd: number
}

export namespace AnnouncementItemType {
  export const SUBJECT_WITHOUT_CONTRACTS = 'subject_without_contracts'
  export const CONTRACTS_NEXT_EXPIRATION = 'contracts_next_expiration'
  export const PROCEDURES_IN_PROGRESS = 'procedures_in_progress'
  export const INCIDENT_PROCEDURES = 'incident_procedures'
  export const WITHOUT_ANNOUNCEMENT = 'without_announcement'
}
export type AnnouncementItemTypes = (typeof AnnouncementItemType)[keyof typeof AnnouncementItemType]

export namespace KPIItemType {
  export const ACTIVE_CONTRACTS = 'active_contracts'
  export const BALANCE_30 = 'balance_30'
  export const BALANCE_YTD = 'balance_ytd'
}
export type KPIItemTypes = (typeof KPIItemType)[keyof typeof KPIItemType]
